<template>
  <div v-if="loaded && workshop">
    <template
        v-if="workshop.contact_1 || workshop.contact_2 || workshop.contact_3 || workshop.contact_4 || workshop.contact_5">
      <div class="container-fluid contact-container">
        <div id="content" class="col-lg-6 m-auto">
          <div class="contact_title_text">{{ $t('medtastic.contact_title_text') }}</div>

          <div v-if="workshop.contact_1" class="row mb-5">
            <div class="col-12 col-sm-3">
              <div
                v-if="workshop.contact_1_pic" 
                class="mr-5"
                :style="{
                  'background-image': 'url(\'/storage/' + workshop.contact_1_pic['path']+'\')',
                  width: '121px',
                  height: '121px',
                  borderRadius: '50%',
                  backgroundSize: 'cover',
                  backgroundColor: 'white',
                  display: 'inline-block'
                }">
              </div>
              <b-img v-else v-bind="blankImg" rounded="circle">
              </b-img>
            </div>
            <div class="col-12 col-sm-9 mt-5 mt-sm-0">
              <div class="list-text" v-html="workshop.contact_1"></div>
            </div>
          </div>
          <div v-if="workshop.contact_2" class="row mb-5">
            <div class="col-12 col-sm-3">
              <div
                v-if="workshop.contact_2_pic" 
                class="mr-5"
                :style="{
                  'background-image': 'url(\'/storage/' + workshop.contact_2_pic['path']+'\')',
                  width: '121px',
                  height: '121px',
                  borderRadius: '50%',
                  backgroundSize: 'cover',
                  backgroundColor: 'white',
                  display: 'inline-block'
                }">
              </div>
              <b-img v-else v-bind="blankImg" rounded="circle">
              </b-img>
            </div>
            <div class="col-12 col-sm-9 mt-5 mt-sm-0">
              <div class="list-text" v-html="workshop.contact_2"></div>
            </div>
          </div>
          <div v-if="workshop.contact_3" class="row mb-5">
            <div class="col-12 col-sm-3">
              <div
                v-if="workshop.contact_3_pic" 
                class="mr-5"
                :style="{
                  'background-image': 'url(\'/storage/' + workshop.contact_3_pic['path']+'\')',
                  width: '121px',
                  height: '121px',
                  borderRadius: '50%',
                  backgroundSize: 'cover',
                  backgroundColor: 'white',
                  display: 'inline-block'
                }">
              </div>
              <b-img v-else v-bind="blankImg" rounded="circle">
              </b-img>
            </div>
            <div class="col-12 col-sm-9 mt-5 mt-sm-0">
              <div class="list-text" v-html="workshop.contact_3"></div>
            </div>
          </div>
          <div v-if="workshop.contact_4" class="row mb-5">
            <div class="col-12 col-sm-3">
              <div
                v-if="workshop.contact_4_pic" 
                class="mr-5"
                :style="{
                  'background-image': 'url(\'/storage/' + workshop.contact_4_pic['path']+'\')',
                  width: '121px',
                  height: '121px',
                  borderRadius: '50%',
                  backgroundSize: 'cover',
                  backgroundColor: 'white',
                  display: 'inline-block'
                }">
              </div>
              <b-img v-else v-bind="blankImg" rounded="circle">
              </b-img>
            </div>
            <div class="col-12 col-sm-9 mt-5 mt-sm-0">
              <div class="list-text" v-html="workshop.contact_4"></div>
            </div>
          </div>
          <div v-if="workshop.contact_5" class="row mb-5">
            <div class="col-12 col-sm-3">
              <div
                v-if="workshop.contact_5_pic" 
                class="mr-5"
                :style="{
                  'background-image': 'url(\'/storage/' + workshop.contact_5_pic['path']+'\')',
                  width: '121px',
                  height: '121px',
                  borderRadius: '50%',
                  backgroundSize: 'cover',
                  backgroundColor: 'white',
                  display: 'inline-block'
                }">
              </div>
              <b-img v-else v-bind="blankImg" rounded="circle">
              </b-img>
            </div>
            <div class="col-12 col-sm-9 mt-5 mt-sm-0">
              <div class="list-text" v-html="workshop.contact_5"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  layout: 'user',
  data () {
    return {
      loaded: false,
      workshop: null,
      imgProps: { blank: false, blankColor: '#D5D5D5', width: 122, height: 122, class: 'm1' },
      blankImg: { blank: true, blankColor: '#D5D5D5', width: 122, height: 122, class: 'm1' }
    }
  },
  mounted () {
    this.workshopDetail()
  },
  methods: {
    workshopDetail: function () {
      axios.get('/api/medtastic/workshops/public?filter%5Bid%5D=' + this.$route.params.id)
          .then((response) => {
            this.workshop = response.data.data[0]
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
            this.loaded = true
          })
    }
  }
}
</script>
